import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import heroImage from "@/assets/hero_image_kids_phones.jpg";
import { Check } from "lucide-react";

const Hero = () => {
  return (
    <section className="relative min-h-[80vh] lg:min-h-screen flex items-center overflow-hidden" style={{ backgroundColor: '#242424' }}>
      {/* Green Gradient Orb - Top Left */}
      <div 
        className="absolute w-[200px] h-[200px] lg:w-[310px] lg:h-[310px] rounded-full blur-[200px] lg:blur-[430px] pointer-events-none"
        style={{
          top: '-40px',
          left: '-62px',
          backgroundColor: '#B0F18D',
          opacity: 0.5,
        }}
      />
      
      {/* Purple Gradient Orb - Bottom Right */}
      <div 
        className="absolute w-[250px] h-[250px] lg:w-[405px] lg:h-[405px] rounded-full blur-[200px] lg:blur-[430px] pointer-events-none"
        style={{
          bottom: '-100px',
          right: '-100px',
          backgroundColor: '#533DDA',
        }}
      />
      
      <div className="container mx-auto px-4 z-10">
        <div className="flex items-center justify-between">
          {/* Text Content */}
          <div className="max-w-xl w-full lg:w-auto">
            {/* Headline */}
            <h1 
              className="text-white mb-4 lg:mb-6 font-semibold"
              style={{
                fontSize: 'clamp(32px, 5vw, 55px)',
                lineHeight: 1.2,
                letterSpacing: '-0.05em',
              }}
            >
              Imagine Getting Everything <span style={{ color: '#B0F18D' }}>You Want.</span>
            </h1>
            
            {/* Subtext */}
            <p
              className="font-medium mb-4 lg:mb-6"
              style={{
                color: '#B0F18D',
                fontSize: 'clamp(14px, 1.5vw, 18px)',
                letterSpacing: '-0.02em',
              }}
            >
              The first mobile plan designed to build your credit
            </p>

            {/* Supporting Text */}
            <ul
              className="text-white/90 mb-6 lg:mb-8 space-y-2"
              style={{
                fontSize: "clamp(16px, 2vw, 25px)",
                lineHeight: 1.4,
                letterSpacing: "-0.05em",
              }}
            >
              {[
                "Wireless plans starting at $7.99/mo",
                "Build credit history and improve your financial wellness",
                "5G on AT&T's nationwide network for fast, reliable coverage",
              ].map((line) => (
                <li key={line} className="flex items-start gap-2">
                  <Check
                    className="mt-1 h-5 w-5 flex-shrink-0"
                    style={{ color: "#B0F18D" }}
                  />
                  <span>{line}</span>
                </li>
              ))}
            </ul>
            
            {/* Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
              <Link to="/plans" className="w-full sm:w-auto">
                <Button 
                  className="w-full sm:w-[200px] lg:w-[220px] h-[52px] lg:h-[59px] rounded-[11px] font-semibold text-base lg:text-lg"
                  style={{ 
                    backgroundColor: '#B0F18D',
                    color: '#000000',
                  }}
                >
                  Get A Plan
                </Button>
              </Link>
              <a href="#how-it-works" className="w-full sm:w-auto">
                <Button
                  className="w-full sm:w-[200px] lg:w-[220px] h-[52px] lg:h-[59px] rounded-[11px] font-semibold text-base lg:text-lg"
                  style={{
                    backgroundColor: '#533DDA',
                    color: '#FFFFFF',
                  }}
                >
                  How It Works
                </Button>
              </a>
            </div>
          </div>
          
          {/* Hero Image - Desktop Only */}
          <div className="hidden lg:block flex-shrink-0 ml-8 relative">
            <div
              role="img"
              aria-label="Group of young people using phones - Perch Mobile"
              className="rounded-[40px] bg-cover bg-center"
              style={{
                width: '540px',
                height: '518px',
                backgroundImage: `url(${heroImage})`,
              }}
            />

            {/* Stat card — overlaps bottom edge of image */}
            <div
              className="absolute -bottom-7 left-5 flex items-center gap-4 px-5 py-4 rounded-2xl"
              style={{
                backgroundColor: 'rgba(18,18,24,0.82)',
                backdropFilter: 'blur(20px)',
                WebkitBackdropFilter: 'blur(20px)',
                border: '1px solid rgba(255,255,255,0.1)',
              }}
            >
              {/* Arrow icon circle */}
              <div
                className="flex items-center justify-center rounded-full flex-shrink-0"
                style={{ width: '44px', height: '44px', backgroundColor: 'rgba(176,241,141,0.18)' }}
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M10 15V5M10 5L5 10M10 5L15 10" stroke="#B0F18D" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>

              {/* Text */}
              <div>
                <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '12px', marginBottom: '2px' }}>
                  Average Credit Boost
                </p>
                <p className="font-bold leading-none" style={{ color: '#FFFFFF', fontSize: '26px', letterSpacing: '-0.03em' }}>
                  +42 <span style={{ color: '#B0F18D' }}>pts</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
